/* src/app/modules/employees/tiempo/tiempo-form.component.css */
.mat-mdc-dialog-content {
  min-height: 150px;
  padding: 20px;
}
.mat-mdc-form-field {
  width: 100%;
}
.mat-mdc-dialog-actions {
  padding: 20px;
  margin-bottom: 0;
}
.mat-mdc-dialog-title {
  margin: 0;
  padding: 20px;
  background-color: #f5f5f5;
  font-size: 20px;
  font-weight: 500;
}
textarea {
  resize: none;
}
.ml-2 {
  margin-left: 0.5rem;
}
button[mat-stroked-button] {
  margin: 0 4px;
}
.w-100 {
  width: 100%;
}
/*# sourceMappingURL=tiempo-form.component.css.map */
